import { API } from './api';

export class StationsService {
  public async getStations(): Promise<Station[] | []> {
    try {
      const { data }: { data: StationsResponse } = await API.get('/estacoes-meteorologicas');
      return data.dados;
    } catch (error) {
      console.error('Error fetching stations:', error);
      throw error;
    }
  }
}

export interface StationsResponse {
  dados: Station[];
  mensagem: string;
  sucesso: boolean;
}

export interface Station {
  lastReading: number;
  precipitationDay: number;
  precipitationHour: number;
  precipitationStorm: number;
  station: string;
  latitude: number;
  longitude: number;
}

 